module.exports = __webpack_public_path__ + "static/media/videoEditor-6.1a94bde6.webp";